module.exports = __webpack_public_path__ + "static/media/logo-linkedin-hover.b704cbfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-linkedin-hover.svg
// module id = 685
// module chunks = 0